import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import HttpError from '../../classes/HttpError';
// translate
import messages from './messages';

class ErrorComponent extends Component {
  renderError(error) {
    const { intl } = this.props;

    let text = intl.formatMessage(messages.defaultMessage);

    if (error instanceof HttpError) {
      text = error.message;
    }

    return text;
  }

  render() {
    const { children } = this.props;

    return (
      <div className="popup-form-error">
        {this.renderError(children)}
      </div>
    );
  }
}

ErrorComponent.propTypes = {
  intl: intlShape.isRequired,
  children: PropTypes.any,
};

ErrorComponent.defaultProps = {
  children: [],
};

export default injectIntl(ErrorComponent);



// WEBPACK FOOTER //
// ./src/components/Error/index.js